import {menusNames as mn, menuProps as mp} from "../../constants/menus";

// initial state
const state = {
    //list: jsonData.featured.list,
    media: null,
    reels: jsonData.featured.reels,
    reel: null,
}

// getters
const getters = {
    reels(state) {
        return state.reels || []
    },
    reel(state) {
        return state.reel
    },
    medias(state) {
        return state.reel && state.reel.list || []
    },
    media(state) {
        return state.media
    },
    recentMedias(state) {
        return state.reels && state.reels[0].list || []
    },
    _loaded: (state, getters) => {
        //debugger
        return getters.medias.filter((media) => media._loaded)
    },
}

// actions
const actions = {
    clean({commit}) {
        commit('clean')
    },
    initFeatureState({commit, dispatch, state}, params) {
        dispatch('player/clean', params, {root: true})
        dispatch('clean')
        dispatch('initReel', params)
        dispatch('initMedia', params)
    },
    initReel({commit, state}, params) {
        //debugger

        let reels = state.reels
        let reel = null

        if (params.reel && reels.length) {
            reel = reels.find((reel, ind, arr) => reel.slug === params.reel)
        } else if (!params.reel && reels.length) {
            reel = reels[0]
        }

        commit('setReel', reel)
    },
    initMedia({commit, state, rootState, rootGetters}, params) {
        let reel = state.reel

        if (!reel) {
            return
        }
        let medias = reel.list
        let media = medias.find((media) => media.slug === params.detail)

        commit('setMedia', media)

        if (media) {
            commit('player/setBack', rootGetters['routes/getProp'](mn.FEATURED_WORK, mp.LINK), {root: true})
            //commit('player/setList', state.list, {root: true})
            commit('player/setList', medias, {root: true})
            commit('player/setCurrent', media, {root: true})
        } else {
            commit('player/setBack', '/', {root: true})
        }
    },
}

// mutations
const mutations = {
    clean(state) {
        state.reel = null
        state.media = null
    },
    setMedia(state, media) {
        //debugger
        state.media = media
    },
    setReel(state, reel) {
        state.reel = reel
    },
    setLoadedMedia(state, media) {
        //debugger
        Vue.set(media, '_loaded', true)
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
